import { render, staticRenderFns } from "./001xinshidaiwenming.vue?vue&type=template&id=28d250bb&scoped=true&"
import script from "./001xinshidaiwenming.vue?vue&type=script&lang=js&"
export * from "./001xinshidaiwenming.vue?vue&type=script&lang=js&"
import style0 from "./001xinshidaiwenming.vue?vue&type=style&index=0&id=28d250bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d250bb",
  null
  
)

export default component.exports